<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <div class="modal-header">
        <h2>Chi tiết NCC</h2>
        <div>
          <button v-if="!isEdit" @click="isEdit = true">✏️ Sửa</button>
          <button v-if="isEdit" @click="handleUpdate">💾 Lưu</button>
          <button @click.self="$emit('close')">✖</button>
        </div>
      </div>

      <div class="modal-body">
        <div class="form-group">
          <label for="">Tên NCC </label>
          <input
            v-model="form.name"
            :class="error.name ? 'error' : ''"
            type="text"
            placeholder="Nhập tên NCC..."
            @input="delete error.name"
            :disabled="!isEdit"
          />
          <span v-if="error.name" class="error-message">
            {{ error.name }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Điện thoại</label>
          <input
            v-model="form.phone"
            :class="error.phone ? 'error' : ''"
            type="tel"
            placeholder="Nhập sdt..."
            @input="delete error.phone"
            :disabled="!isEdit"
          />
          <span v-if="error.phone" class="error-message">
            {{ error.phone }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Địa chỉ</label>
          <input
            v-model="form.address"
            type="text"
            placeholder="Nhập địa chỉ..."
            :disabled="!isEdit"
          />
          <span v-if="error.address" class="error-message">
            {{ error.address }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Email</label>
          <input
            v-model="form.email"
            type="email"
            placeholder="Nhập Email..."
            :disabled="!isEdit"
          />
          <span v-if="error.email" class="error-message">
            {{ error.email }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Nhóm NCC</label>
          <input
            v-model="form.nhom_ncc"
            type="text"
            placeholder="VD: Hàng New, Linh kiện..."
            :disabled="!isEdit"
          />
          <span v-if="error.nhom_ncc" class="error-message">
            {{ error.nhom_ncc }}
          </span>
        </div>
        <div class="form-group">
          <label for="">Ghi chú</label>
          <input v-model="form.ghi_chu" type="text" :disabled="!isEdit" />

          <span v-if="error.ghi_chu" class="error-message">
            {{ error.ghi_chu }}
          </span>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-save" @click="handleSave">Lưu</button>
        <button @click.self="$emit('close')">Huỷ</button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useToast } from "@/composables/useToast";
// import { supplierApi } from "@/services/api";
import { reactive, ref, toRefs, watch } from "vue";

const props = defineProps({
  supplier: {
    type: Object,
    required: true,
  },
});
const toast = useToast();
const { supplier } = toRefs(props);
const originalData = ref({});
const form = reactive({});
const error = ref({});
const isEdit = ref(false);
watch(
  () => supplier.value,
  (val) => {
    Object.assign(form, val);
    originalData.value = JSON.parse(JSON.stringify(val));
  },
  {
    immediate: true,
    deep: true,
  },
);
const validateForm = () => {
  error.value = {};
  let isValid = true;
  if (!form.name) {
    error.value.name = "Vui lòng nhập tên nhà cung cấp";
    isValid = false;
  }
  if (!form.phone) {
    error.value.phone = "Vui lòng nhập số điện thoại";
    isValid = false;
  }
  if (form.phone) {
    const cleanPhone = form.phone.replace(/[^0-9+]/g, "");
    const phoneRegex = /^(0|84|(\+84))(3|5|7|8|9)[0-9]{8}$/;
    if (!phoneRegex.test(cleanPhone)) {
      error.value.phone = "Số điện thoại không đúng định dạng (10 số)";
      isValid = false;
    } else {
      form.phone = cleanPhone;
    }
  }
  return isValid;
};
const handleUpdate = async () => {
  if (!validateForm) return;
  try {
    // await supplierApi.updateSupplier(form.id, form);
    toast.success("Cập nhật nhà cung cấp thành công");
    isEdit.value = false;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      error.value = error.response.data.errors;
    }
    const errorMessage = error.response.data.error || "Lỗi khi thêm sản phẩm";
    toast.error(errorMessage);
  }
};
// const handleSave = async () => {
//   const formData = new FormData();
//   Object.keys(form).forEach((key) => {
//     let value = form[key];
//     if (value === null || value === undefined) value = "";
//     if (typeof value === "boolean") value = value ? 1 : 0;
//     formData.append(key, value);
//   });
//   if (validateForm()) {
//     loading.value = true;
//     try {
//       await supplierApi.createNewSupplier(formData);
//       toast.success("Thêm mới nhà cung cấp thành công");
//       emit("save");
//     } catch (error) {
//       if (error.response && error.response.status === 422) {
//         error.value = error.response.data.errors;
//       }
//       const errorMessage = error.response.data.error || "Lỗi khi thêm sản phẩm";
//       toast.error(errorMessage);
//     } finally {
//       loading.value = false;
//     }
//   }
// };
</script>
<style scoped>
.form-group {
  margin: 10px 0;
}
.modal-header button {
  margin-left: 10px;
}
</style>
